import React from 'react';
import './phrase-highlighted.scss'
export function PhraseHighlighted ({ phrase }) {

  return(
    <h1 className="phrase-highlighted" > { phrase } </h1>
  );
}
